import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ProgressBar } from '@xing-com/progress-bar';
import { spaceS, xdlColorChart01 } from '@xing-com/tokens';
import { Meta } from '@xing-com/typography';

const Caption = styled(Meta)`
  padding-top: ${spaceS};
`;

const REVIEW_MODE_PROGRESS_PERCENTAGE = 98;

type WizardProgressBarProps = {
  currentStep: number;
  totalSteps: number;
  isReviewMode: boolean;
};

export const WizardProgressBar: React.FC<WizardProgressBarProps> = ({
  currentStep,
  totalSteps,
  isReviewMode,
}) => {
  const progress = useMemo(() => {
    if (isReviewMode) return REVIEW_MODE_PROGRESS_PERCENTAGE;
    if (totalSteps <= 0) return 100;

    return Math.round((currentStep / totalSteps) * 100) || 100;
  }, [currentStep, totalSteps, isReviewMode]);

  const captionMessageId = isReviewMode
    ? 'JOBS_APPLY_WIZARD_PROGRESS_BAR_CAPTION_REVIEW'
    : 'JOBS_APPLY_WIZARD_PROGRESS_BAR_STEP';

  return (
    <>
      <ProgressBar
        progress={progress}
        showLabel={false}
        progressBarColor={xdlColorChart01}
        data-testid="wizard-progress-bar"
      />
      <Caption size="small" sizeConfined="medium" noMargin>
        <FormattedMessage
          id={captionMessageId}
          values={{ currentStep, totalSteps }}
        />
      </Caption>
    </>
  );
};
